import React from "react"
import {Checkbox, Form} from "antd"

export default class GiftAid extends React.Component {

    render() {
        const {assocInfo} = this.props

        if(assocInfo._format!=="UK"){
            return null
        }

        return (
            <Form.Item noStyle shouldUpdate={true}>
                {(form) => {

                    const isAbo=form.getFieldValue("abo") || false

                    const isPerso = form.getFieldValue("perso") || false

                    if(!isPerso){
                        return null
                    }

                    // AAC interdit explicitement le Gift Aid (déjà appliqué côté AAC
                    // sur le crédit du compte donateur). On force giftAid:false et on
                    // masque tout le bloc.
                    const platform = form.getFieldValue("platform")
                    if(platform === "AAC"){
                        if(form.getFieldValue("giftAid")){
                            form.setFieldsValue({giftAid: false})
                        }
                        return null
                    }


                    return (
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            padding: "20px 0"
                        }}>

                            <p style={{
                                margin: 0,
                                color: "#1f1f1f",
                                fontSize: 15,
                                lineHeight: 1.5
                            }}>
                                Gift Aid lets <strong>{assocInfo.nom}</strong> claim an extra 25p for every £1 you donate, at no extra cost to you.
                            </p>

                            <Form.Item name={"giftAid"} valuePropName={"checked"} style={{marginTop:10,marginBottom:0}}>
                                <Checkbox>
                                    I want Gift Aid to apply to this donation, any donations I make in the future and any donations I made in the past 4 years.
                                </Checkbox>
                            </Form.Item>

                            <p style={{
                                margin: "8px 0 0 24px",
                                color: "#8c8c8c",
                                fontSize: 11,
                                lineHeight: 1.45
                            }}>
                                I am a UK taxpayer and understand that if I pay less Income Tax and/or Capital Gains Tax than the amount of Gift Aid claimed on all my donations in that tax year, it is my responsibility to pay any difference. This declaration applies to donations made to {assocInfo.nom}{assocInfo.rna ? ` (Charity No ${assocInfo.rna})` : ""} until I notify the charity otherwise.
                            </p>
                        </div>
                    )
                }}
            </Form.Item>


        )
    }
}
